<template>
    <div class="searchGrade" >
        <div class="grade-item" v-for="(item,index) in washServiceGradeList" :key="index" @click="onGrade(item)">
            {{ item.gradeName }}
        </div>
    </div>
</template>

<script>
import { get, postJson, post } from '@/utils/request.js';

export default {
    data(){
        return{
            washServiceGradeList: [],
        }
    },
    mounted() {
        this.getWashProductGradeList();
    },
    methods:{
        getWashProductGradeList(){
            get("/wash/utils/findAllWashServiceGrade").then((res)=>{
                if(res.success){
                    this.washServiceGradeList = res.list
                }
            })
        },

        onGrade(gradeItem){
            this.$emit("onGrade", gradeItem)
        }
    }
}
</script>

<style scoped lang="scss">
.searchGrade{
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .grade-item{
        display: inline-block;
        margin:  0 0 10px 10px;
        padding: 12px 20px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        cursor: pointer;
    }

}
</style>